// extracted by mini-css-extract-plugin
export default {"statsGrid":"PaperJournalSummaryCard_statsGrid__TiRE+"};